<template>
  <div class="tw-border-b tw-border-[#C7C7C7] tw-mt-1 tw-py-5">
    <button
      v-b-toggle="dynamicId"
      class="tw-text-[24px] md:tw-text-[26px] lg:tw-text-[30px] tw-flex tw-w-full tw-justify-between tw-items-start tw-text-start tw-leading-[28px] tw-font-atten"
    >
      {{ title }}

      <span
        v-if="!isOpen"
        class="tw-w-[4rem] tw-text-right"
      >+</span>
      <span
        v-else
        class="tw-w-[4rem] tw-text-right"
      >-</span>
    </button>
    <b-collapse
      :id="dynamicId"
      class="tw-mt-1 tw-py-3"
      @shown="isOpen = true"
      @hidden="isOpen = false"
    >
      <slot></slot>
    </b-collapse>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'UpsellCollapse',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isOpen: false,
      uniqueId: uuidv4(),
    };
  },
  computed: {
    dynamicId() {
      return `collapse-${this.uniqueId}`;
    },
  },
};
</script>
